import { CommonService } from './../Services/common.service';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from "rxjs";
import { AuthService } from '../Services/auth.service';
import { CookieService } from '../Services/cookie';
import { SettingService } from '../Services/setting.service';
import { browserRefresh } from '../app.component';
@Component({
  selector: 'app-verify-email-mobile',
  templateUrl: './verify-email-mobile.component.html',
  standalone:false,
  styleUrls: ['./verify-email-mobile.component.scss']
})
export class VerifyEmailMobileComponent implements OnInit {

  modalObservable: Subject<void> = new Subject<void>();
  UpdateEmail: string = "";
  IDNo: string = "";
  NewEMail: string;
  NewMOb: any;
  Replace: any;
  Newemail2: string;
  migratedCPR: string;
  noEmail: string;
  flowHere: string;
  idnumber: string;

  constructor(private _route: ActivatedRoute, private CommonService: CommonService, public auth: AuthService, private setting: SettingService,

    private cookieService: CookieService, private _router: Router) { }

  @Output() doneButton: EventEmitter<any> = new EventEmitter<any>();

  mobilemask: string = "";
  email: string = "";
  maskemail: string = "";
  otp: string = "";
  timerexpire: string;
  OptTimerbtnShow: boolean = true;
  timeoutHandle;
  idno;
  public browserRefresh: boolean;
  userEmail:string
  userMobile:string



  async ngOnInit(): Promise<any> {

    // email
    let R = await this.cookieService.get("xerV2r", true);
    if (R) {
      this.userEmail = R;
    }
      // mobile
    let s = await this.cookieService.get("fg2tr", true);
    if (s) {
      this.userMobile = s;
    }
        let Q = await this.cookieService.get("xVal", true);
    if (Q) {
      this.idnumber = Q;
    }

    // 

    this.browserRefresh = browserRefresh;

    console.log('refreshed?:', browserRefresh);



    // user email diplay migrated yousuf
    let Eml =await this.cookieService.get("migr", true);
    if (Eml) {

      this.Newemail2 = Eml;

    }

    let Mcpr =await this.cookieService.get("migratedCpr", true);
    if (Mcpr) {

      this.migratedCPR = Mcpr;

    }

    let notem =await this.cookieService.get("Newemail2", true);
    if (notem) {

      this.noEmail = notem;

    }

    let flow =await this.cookieService.get("Flow1", true);
    if (flow) {

      this.flowHere = flow;

    }
    console.log("Newemail2", this.Newemail2);
    console.log("migratedCPR", this.migratedCPR);
    console.log("noEmail", this.noEmail);
    console.log("flowHere", this.flowHere);



    // 

    this.startTime();
    this._route.queryParams.subscribe(params => {
      if (params) {

        if (params['maskemail']) {

        }
        if (params['UpdateEmail']) {

          this.UpdateEmail = params['UpdateEmail'];
        }
        if (params['IDNo']) {

          this.IDNo = params['IDNo'];
        }
      }
    });

    if (this.maskemail == undefined || this.maskemail == '') {

      let E =await this.cookieService.get("eRef", true);
      if (E) {

        this.maskemail = E;

      }
    }

    if (this.auth?.RegisteredUser == undefined && (this.IDNo == "" || this.IDNo == undefined)) {

      let R = await this.cookieService.get("xVal", true);
      if (R) {

        this.IDNo = R;



      }
      console.log("IncreptedIDNo", this.IDNo);

    }


    this.auth.accessToken = await this.CommonService.Get("token");








    let UE =await this.cookieService.get("UpdatedEmail", false);
    if (UE) {

      this.NewEMail = JSON.parse(UE);

      this.maskemail = this.CommonService.maskEmail(this.NewEMail);
    }
    let UM =await this.cookieService.get("upM32B", true);
    if (UM) {

      this.NewMOb = JSON.parse(UM);

    }
  }

  Next() {

    if (this.NewEMail != undefined && this.NewEMail != "") {
      this.VerifyEmailOtp();
    }
    else if (this.NewMOb != undefined && this.NewMOb != "") {

      this.verifyViaEmailOtp();
    }
    else if (this.Replace != undefined && this.Replace != "" && this.Replace == 'PhyReplace') {

      // this.CardReplacementVerifyOTP();
    }
    else {

      this.login()
    }
  }


  async VerifyEmailOtp() {
    let body = {
      EmailId: this.NewEMail,
      OTPCode: this.otp,
    };

    await this.CommonService.presentLoading();
    this.setting.VerifyChangeEmailOTP(this.auth.accessToken, body)
      .then(async (data: any) => {
        if (data?.response?.code == 1) {
          await this.CommonService.hideLoading();
          //this.showModal(num);
          this._router.navigateByUrl("/VerifyMobileOtp");

        } else {
          await this.CommonService.hideLoading();
          this.CommonService.ParseErrorAlert("", "", this._router, data);
        }
      });
  }


  verifyViaEmailOtp() {
    let body = {
      MobileNumber: this.NewMOb,
      OTPCode: this.otp,
    };
    this.CommonService.presentLoading();
    this.setting
      .VerifyChangeMobileEmailOTP(this.auth.accessToken, body)
      .then((data: any) => {
        if (data?.response.code == 1) {
          this.CommonService.hideLoading();
          this._router.navigateByUrl("/VerifyMobileOtp");
        } else {
          this.CommonService.hideLoading();
          this.CommonService.ParseErrorAlert("", "", this._router, data);
        }
      });
  }

  // LoginRegisterEmailOTP() {
  //

  //   this.CommonService.presentLoading();
  //   if (this.maskemail && this.UpdateEmail != '') {
  //
  //     let body = {
  //       UniqueId: this.CommonService.Guid(),
  //       IdNumber: this.IDNo ? this.IDNo : this.auth.RegisteredUser.idno,
  //       EmailId: this.UpdateEmail,
  //       isBusiness: false,
  //       firebaseToken: "string",
  //       otp: this.otp

  //     }
  //     this.auth.SendUpdateEmailSMSOTP(body).then((data: any) => {
  //
  //       console.log('SendUpdateEmailSMSOTP', data);
  //
  //       if (data?.response?.code == 1) {
  //         this.CommonService.hideLoading();
  //         this._router.navigate(['/VerifyMobileOtp'], { queryParams: { 'IDNo': this.IDNo, 'UpdateEmail': this.UpdateEmail } });

  //       }
  //       else {
  //         this.CommonService.hideLoading();
  //         this.CommonService.ParseErrorAlert('', 'OK', this._router, data);
  //       }

  //     })

  //   }
  //   // 6 digits new api
  //   else if (this.flowHere === "yes") {
  //
  //     let body = {
  //       UniqueId: this.CommonService.Guid(),
  //       IdNumber: this.auth.migratedUser.idNumber,
  //       EmailId: this.auth.migratedUser.emailId,
  //       isBusiness: false,
  //       firebaseToken: "string",
  //       MobileNumber: this.auth.migratedUser.mobileNumber,
  //       otp: this.otp

  //     }
  //     this.auth.SendUpdateEmailSMSOTPV1_TLAPI(body).then((data: any) => {
  //
  //       console.log('SendUpdateEmailSMSOTPV1_TLAPI', data);
  //
  //       if (data?.response?.code == 1) {
  //         this.CommonService.hideLoading();

  //         this._router.navigate(['/VerifyMobileOtp']);


  //       }
  //       else {
  //         this.CommonService.hideLoading();
  //         this.CommonService.ParseErrorAlert('', 'OK', this._router, data);
  //       }

  //     })
  //   }
  //   else {
  //
  //     let body = {
  //       UniqueId: this.CommonService.Guid(),
  //       idNumber: this.auth.RegisteredUser?.idno ? this.auth.RegisteredUser.idno : this.IDNo,
  //       isBusiness: false,
  //       firebaseToken: "string",
  //       otp: this.otp
  //     }
  //     // updated 6 digit otp api yousuf
  //     this.auth.LoginRegisterEmailOTP(body).then((data: any) => {
  //
  //       if (data?.response?.code == 1) {
  //         console.log('LoginRegisterEmailOTP', data);

  //         this.CommonService.hideLoading();
  //         this._router.navigateByUrl("/VerifyMobileOtp");

  //       } else {
  //         this.CommonService.hideLoading();
  //
  //         this.CommonService.ParseErrorAlert('', '', this._router, data);

  //       }
  //     });
  //   }



  // }

// new login api
    login() {
    //
    this.CommonService.presentLoading();
    if (this.IDNo != "" && this.UpdateEmail != "") {
      let body = {
        UniqueId: this.CommonService.Guid(),
        idNumber:this.idnumber,
        IsUpdateEmailFlow: true,
        EmailId: this.UpdateEmail,
        isBusiness: false,
        firebaseToken: "string",
        otp: this.otp,
      };

      this.auth.LoginRegister(body).then((data: any) => {
        //
        if (data?.response?.code == 1) {
          this.CommonService.hideLoading();
          this.auth.deviceid = data.response.content.l.webdeviceId;
          //
          this._router.navigateByUrl("/CreateAppPin");
        } else {
          this.CommonService.hideLoading();
          this.CommonService.ParseErrorAlert("", "", this._router, data);
        }
      });
    } 
    
    // 6 digits flow new otp
 else if (this.flowHere === "yes"){
     let body = {
        UniqueId: this.CommonService.Guid(),
        idNumber: this.auth.migratedUser.idNumber,
        //this.Cpr is refresh issue occors use this
        isBusiness: false,
        firebaseToken: "string",
        IsUpdateEmailFlow: true,
        EmailId: this.auth.migratedUser.emailId,
        otp: this.otp,
        MobileNumber:this.auth.migratedUser.mobileNumber
      };
      this.auth.LoginRegister(body).then((data: any) => {

        if (data?.response?.code == 1) {

          this.auth.deviceid = data.response.content.webdeviceId;

        
          // this.cookieService.set("detailuser",JSON.stringify(data.response.content.l),false,undefined,undefined,undefined,undefined,true,"Strict")

          this.CommonService.hideLoading();
          this._router.navigateByUrl("/Dashboard");

          // if(data.response.content.l.pinCreated){
          //   this._router.navigateByUrl("/DashboardLoans");

          // }else{
          //   this._router.navigateByUrl("/CreateAppPin");
          // }
          // ('LoginRegister',data.response.content.l);
        }
        else if(data?.error?.response?.code == 7){

          this.CommonService.hideLoading();
          this.CommonService.ParseErrorAlert("", "", this._router, data?.error?.response?.message);

        } else {
          this.CommonService.hideLoading();
          this.CommonService.ParseErrorAlert("", "", this._router, data);
        }
      });
 }
    // 
    
    else {
      let body = {
        UniqueId: this.CommonService.Guid(),
        idNumber: this.idnumber,
        isBusiness: false,
        firebaseToken: "string",
        otp: this.otp,
      };
      this.auth.LoginRegister(body).then((data: any) => {

        if (data?.response?.code == 1) {

          this.auth.deviceid = data.response.content.webdeviceId;

        
          // this.cookieService.set("detailuser",JSON.stringify(data.response.content.l),false,undefined,undefined,undefined,undefined,true,"Strict")

          this.CommonService.hideLoading();
          this._router.navigateByUrl("/Dashboard");

          // if(data.response.content.l.pinCreated){
          //   this._router.navigateByUrl("/DashboardLoans");

          // }else{
          //   this._router.navigateByUrl("/CreateAppPin");
          // }
          // ('LoginRegister',data.response.content.l);
        }
        else if(data?.error?.response?.code == 7){

          this.CommonService.hideLoading();
          this.CommonService.ParseErrorAlert("", "", this._router, data?.error?.response?.message);

        } else {
          this.CommonService.hideLoading();
          this.CommonService.ParseErrorAlert("", "", this._router, data);
        }
      });
    }
  }


  onKeyDown(event: KeyboardEvent): void {
    if (event.key === "Enter") {

      if (this.NewEMail != undefined && this.NewEMail != "") {

        this.VerifyEmailOtp();
      }
      else if (this.NewMOb != undefined && this.NewMOb != "") {
        this.verifyViaEmailOtp();
      }
      else if (this.Replace != undefined && this.Replace != "" && this.Replace == 'PhyReplace') {
        // this.CardReplacementVerifyOTP();
      }
      else {

        this.login()
      }
    }
  }





  showModal(num) {

    this.modalObservable.next(num);
  }

  startTime() {
    const expireTime = new Date().getTime() + 2 * 60 * 1000; // 2 minutes from now
    this.startCountdown(expireTime);
  }

  startCountdown(expireTimestamp: number) {
    const tick = () => {
      const now = new Date().getTime();
      const remaining = expireTimestamp - now;

      if (remaining <= 0) {
        this.timerexpire = "0:00";
        this.OptTimerbtnShow = false;
        return;
      }

      const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

      this.timerexpire = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
      setTimeout(tick, 1000);
    };

    tick();
  }


  ResendOtp() {

    this.CommonService.presentLoading();

    let body = {
      UniqueId: this.CommonService.Guid(),
      idNumber: this.auth?.RegisteredUser?.idno ? this.auth.RegisteredUser.idno : this.IDNo

    }

    this.auth.SendOTPByIDNumber(body).then(async (data: any) => {
      //
      if (data?.response?.code == 1) {

        this.OptTimerbtnShow = true;
        this.startTime();
        let email = data?.response?.content?.email;
        this.maskemail = this.CommonService.maskEmail(email);
        this.auth.RegisteredUser.idno = await this.cookieService.get("tempValue", true);
        this.CommonService.hideLoading();

      }
      else {
        this.CommonService.hideLoading();
        this.CommonService.ParseErrorAlert('', '', this._router, data);
      }
    })

  }


  continue() {
    this._router.navigateByUrl("/UploadId");
  }

  isValid() {
    if (!this.otp) {
      return true
    } else {
      return false

    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const otpInputs = document.querySelectorAll('input.otp-input');
      otpInputs.forEach((input: any) => {
        input.setAttribute('inputmode', 'numeric');
        input.setAttribute('pattern', '[0-9]*');
      });
    }, 500);
  }


  onOtpChange(e) {
    if (e.length == 6) {
      this.otp = e.toString();
    } else {
      this.otp = "";
    }
  }

}

